import React, { useState, useCallback, useEffect, useRef } from "react";

import styles from "./index.module.scss";
interface IAvatar {
  initials: string;
  size: string;
  onLogout?(): void;
  onPermissionsShow?(): void;
}

const Avatar = ({ initials, size, onLogout, onPermissionsShow }: IAvatar) => {
  const [showMenu, setShowMenu] = useState(false);
  const container = useRef<HTMLDivElement>(null);

  const onAvatarClick = useCallback(() => {
    setShowMenu(!showMenu);
  }, [showMenu]);

  const handleClickOutside = (event) => {
    if (container.current && !container.current.contains(event.target)) {
      setShowMenu(false);
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles["profile"]} ref={container}>
      <div className={styles["avatar-container"]} onClick={onAvatarClick}>
        <div className={styles["avatar"]}>
          <div className={styles["initials"]}>{initials.toUpperCase()}</div>
        </div>
        <div className={styles["carrot-container"]}>
          <div className={styles["open-carrot"]}>▼</div>
        </div>
        <span className="avatar-down" />
      </div>
      {showMenu && (
        <div className={styles["profile-menu"]}>
          {onPermissionsShow && (
            <div className={styles["profile-menu-item"]} onClick={onPermissionsShow}>
              Permissions
            </div>
          )}
          <div className={styles["profile-menu-item"]} onClick={onLogout}>
            {" "}
            Logout
          </div>
        </div>
      )}
    </div>
  );
};
export default Avatar;
